import type { FC } from 'react';
import { AppShellSkeleton } from 'src/components/layout/app-shell/skeleton';
import { SimplePageLayout } from 'src/components/layout/simple-page-layout';

export const LoadingPage: FC = () => {
  return (
    <>
      <AppShellSkeleton />

      <div className="not-legacy:hidden">
        <SimplePageLayout>
          <p>Welcome to Prisma</p>
        </SimplePageLayout>
      </div>
    </>
  );
};
